import React, { useState, useRef, useEffect } from "react";

import ReactCrop, { centerCrop, makeAspectCrop } from "react-image-crop";
import { canvasPreview } from "./canvasPreview";
import { useDebounceEffect } from "./useDebounceEffect";

import "react-image-crop/dist/ReactCrop.css";
import ModalSkeleton from "../ModalSkeleton";
import { Col, Row } from "react-bootstrap";
import { Button } from "../../Component/Button/Button";

// This is to demonstate how to make and center a % aspect crop
// which is a bit trickier so we use some helper functions.
function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
  return centerCrop(
    makeAspectCrop(
      {
        unit: "px",
        width: 220,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
}

export default function ImageCropPickerModal({
  show,
  setShow,
  picture,
  onSubmit,
}) {
  const [imgSrc, setImgSrc] = useState("");
  let previewCanvasRef = useRef(null);
  let imgRef = useRef(null);
  let hiddenAnchorRef = useRef(null);
  let blobUrlRef = useRef("");
  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState(16 / 9);

  //   onSelectFile
  function onSelectFile(e) {
    if (e.target.files && e.target.files.length > 0) {
      setCrop(undefined); // Makes crop preview update between images.
      const reader = new FileReader();
      reader.addEventListener("load", () =>
        setImgSrc(reader.result?.toString() || "")
      );
      reader.readAsDataURL(e.target.files[0]);
    }
  }

  useEffect(() => {
    typeof picture === "object"
      ? onSelectFile({ target: { files: [picture] } })
      : setImgSrc(picture);
    // setImgSrc(picture);

    return () => {
      setImgSrc(null);
      setCrop(null);
      setCompletedCrop(null);
      imgRef = null;
      previewCanvasRef = null;
      hiddenAnchorRef = null;
    };
  }, [picture]);

  //   onImageLoad
  function onImageLoad(e) {
    if (aspect) {
      const { width, height } = e.currentTarget;
      setCrop(centerAspectCrop(aspect));
    }
  }

  //   onDownloadCropClick
  function onDownloadCropClick() {
    if (!previewCanvasRef.current) {
      throw new Error("Crop canvas does not exist");
    }
    // create file
    previewCanvasRef.current.toBlob((blob) => {
      console.log(blob, "blob blob blob");

      var canvas = document.getElementById("canvas");
      let video = document.getElementById("newCanvas");
      console.log(video, "video video video");
      const test = canvas.getContext("2d").drawImage(video, 0, 0, 250, 400);
      // test.scale(3, 3);
      const dataUrl = canvas.toDataURL();

      const immm = `data:image/jpeg;base64,${dataUrl}`;

      var image = new Image();
      console.log(immm, "immm immm immm");
      image.onload = function () {
        test.drawImage(image, 0, 0, 250, 400);
      };
      image.src = immm;
      let imageBuffer = canvas.toDataURL();

      return onSubmit(blob);
      if (!blob) {
        throw new Error("Failed to create blob");
      }
      if (blobUrlRef.current) {
        URL.revokeObjectURL(blobUrlRef.current);
      }
      blobUrlRef.current = URL.createObjectURL(blob);
      hiddenAnchorRef.current.href = blobUrlRef.current;
      hiddenAnchorRef.current.click();
    });
  }

  // useDebounceEffect
  useDebounceEffect(
    async () => {
      if (
        completedCrop?.width &&
        completedCrop?.height &&
        imgRef.current &&
        previewCanvasRef.current
      ) {
        // We use canvasPreview as it's much faster than imgPreview.
        canvasPreview(
          imgRef.current,
          previewCanvasRef.current,
          completedCrop,
          scale,
          rotate
        );
      }
    },
    100,
    [completedCrop, scale, rotate]
  );

  return (
    <ModalSkeleton
      setShow={setShow}
      show={show}
      width={"900px"}
      header={"Crop Image"}
      borderRadius={"20px"}
      showCloseIcon
    >
      <Row>
        <Col>
          {!!imgSrc && (
            <ReactCrop
              className="custom_crop"
              crop={crop}
              onChange={(_, percentCrop) => setCrop(percentCrop)}
              onComplete={(c) => setCompletedCrop(c)}
              aspect={0.8}
            >
              <div
                style={{
                  height: "300px",
                  width: "300px",
                }}
              >
                <img
                  ref={imgRef}
                  alt="Crop me"
                  src={imgSrc}
                  style={{
                    transform: `scale(${scale}) rotate(${rotate}deg)`,

                    height: "100%",
                    width: "100%",
                  }}
                  onLoad={onImageLoad}
                />
              </div>
            </ReactCrop>
          )}
        </Col>

        {![0, NaN, "0", "NaN", null, undefined].includes(
          completedCrop && crop?.height
        ) && (
          <Col>
            <div
              style={{
                height: "300px",
                width: "300px",
              }}
            >
              <canvas
                ref={previewCanvasRef}
                id="newCanvas"
                style={{
                  height: "100%",
                  width: "100%",
                  border: "1px solid black",
                  objectFit: "fill",
                  width: completedCrop.width,
                  height: completedCrop.height,
                }}
              />
            </div>
          </Col>
        )}
      </Row>
      <Row className="d-flex justify-content-end align-items-center mt-3">
        <Button
          label={"Next"}
          onClick={onDownloadCropClick}
          customStyle={{ width: "200px" }}
        />
        {/* <a
                ref={hiddenAnchorRef}
                download
                style={{
                  position: "absolute",
                  top: "-200vh",
                  visibility: "hidden",
                }}
              >
                Hidden download
              </a> */}
      </Row>
    </ModalSkeleton>
  );
}
